import { ComponentsOverrides, Theme } from "@mui/material";

type MuiTab = {
  styleOverrides: ComponentsOverrides<Theme>["MuiTab"];
};

const muiTab: MuiTab = {
  styleOverrides: {
    root: {
      textTransform: "unset",
    },
  },
};

export default muiTab;
